<div class="header-wrapper">
  <div>
    <fa-icon
      *ngIf="!isMobileScreen"
      [icon]="icons['faBars']"
      class="header-icon"
      (click)="onCloseClicked($event)"
      data-cy="nav-toggle"
    />
  </div>

  <div>
    <button
      #btn
      type="button"
      pButton
      icon="pi pi-angle-down"
      [label]="fullUserName"
      (click)="menu.toggle($event)"
      data-cy="coalition-header-dropdown"
    ></button>
    <p-tieredMenu #menu [model]="items" [popup]="true"></p-tieredMenu>
  </div>
</div>
